import React from 'react';
import { motion } from 'framer-motion';

const CallToAction: React.FC = () => {
  return (
    <div className="gradient-bg py-24">
      <div className="container mx-auto px-4 text-center">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-4xl md:text-5xl font-bold mb-6"
        >
          Ready to automate your business?
        </motion.h2>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-xl text-gray-300 max-w-3xl mx-auto mb-10"
        >
          Let's build powerful AI systems and automations designed to streamline your operations, 
          boost efficiency, and scale your business with confidence.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <a 
            href="#contact" 
            className="bg-accent hover:bg-accent-light text-white font-medium px-8 py-4 rounded-md text-lg transition-all duration-300 inline-block"
          >
            Schedule a consultation
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default CallToAction;
